const selectors = {
  item: '[data-past-event-item]',
  viewMore: '[data-past-events-view-more]',
  loadMoreBtn: '[data-past-events-load-more]',
};

const DEFAULT_INITIAL = 8;
const DEFAULT_LOAD_MORE = 8;

export default class DynamicPastEvents {
  constructor(section) {
    this.el = section.el;
    const d = section.data;
    this.initialVisible = d.initialVisible ?? DEFAULT_INITIAL;
    this.loadMoreCount = d.loadMoreCount ?? DEFAULT_LOAD_MORE;

    this.items = [...this.el.querySelectorAll(selectors.item)];
    this.viewMore = this.el.querySelector(selectors.viewMore);

    if (this.items.length === 0 || !this.viewMore) {
      return;
    }

    this.visibleCount = Math.min(this.initialVisible, this.items.length);

    this.viewMore
      .querySelector(selectors.loadMoreBtn)
      ?.addEventListener('click', () => this.onLoadMore());

    this.syncVisibility();
  }

  onLoadMore() {
    this.visibleCount = Math.min(
      this.visibleCount + this.loadMoreCount,
      this.items.length,
    );
    this.syncVisibility();
  }

  syncVisibility() {
    this.items.forEach((item, i) => {
      item.classList.toggle('hidden', i >= this.visibleCount);
    });

    this.viewMore.classList.toggle(
      'hidden',
      this.visibleCount >= this.items.length,
    );
  }
}
